import React from 'react'
import { CoverEl } from '../elements'
import ArtistInfoStore from '../stores/artist-info-store'

const Cover = () => {
  const {
    data: {
      profile: { cover },
    },
  } = ArtistInfoStore.useContainer()

  return <CoverEl>{cover && <img src={cover} alt={'cover'} />}</CoverEl>
}

export default Cover
